import {FieldConfig} from '../../dynamic-field/field.config';
import {LabelDividerPositionEnum} from './label-divider-position.enum';

export interface DividerFieldConfig extends FieldConfig<string> {
    lineWidth: number;
    lineColor: string;
    labelPosition: LabelDividerPositionEnum;
}
